module.exports = __webpack_public_path__ + "static/media/collage-1.38df567d.png";